import { Link } from "react-router-dom";
import { Separator } from "@/components/ui/separator";
import { Mail, MapPin } from "lucide-react";
import { Reveal } from "@/components/ui/reveal";

export const Footer = () => {
  return (
    <footer className="bg-secondary/30 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Brand Column */}
          <Reveal delay={40}>
            <Link to="/" className="inline-block">
              <span className="font-display text-2xl font-semibold text-foreground">
                ROSKAM
              </span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
              A pilot wool product rooted in the Roskam family farm.
              Join the waitlist to be first in line.
            </p>
            <div className="mt-6 flex items-center gap-2 text-sm text-muted-foreground">
              <MapPin className="h-4 w-4" />
              <span>Noordoostpolder + Overijssel, NL</span>
            </div>
            <div className="mt-3 flex items-center gap-2 text-sm text-muted-foreground">
              <Mail className="h-4 w-4" />
              <a href="mailto:mvonk4015@gmail.com" className="hover:text-foreground transition-colors link-underline">
                [PLACEHOLDER MAIL]
              </a>
            </div>
          </Reveal>

          {/* Navigation */}
          <Reveal delay={120}>
            <h4 className="font-display text-lg font-medium text-foreground mb-4">Explore</h4>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-muted-foreground hover:text-foreground transition-colors link-underline">
                Home
              </Link>
              <Link to="/about" className="text-sm text-muted-foreground hover:text-foreground transition-colors link-underline">
                About the Farm
              </Link>
              <Link to={{ pathname: "/", hash: "#waitlist" }} className="text-sm text-muted-foreground hover:text-foreground transition-colors link-underline">
                Join the Waitlist
              </Link>
              <Link to={{ pathname: "/", hash: "#contact" }} className="text-sm text-muted-foreground hover:text-foreground transition-colors link-underline">
                Contact
              </Link>
            </nav>
          </Reveal>

          {/* Policies */}
          <Reveal delay={200}>
            <h4 className="font-display text-lg font-medium text-foreground mb-4">Policies</h4>
            <nav className="flex flex-col gap-2">
              <Link to={{ pathname: "/", hash: "#returns" }} className="text-sm text-muted-foreground hover:text-foreground transition-colors link-underline">
                Return Policy
              </Link>
              <Link to={{ pathname: "/", hash: "#privacy" }} className="text-sm text-muted-foreground hover:text-foreground transition-colors link-underline">
                Privacy Policy
              </Link>
            </nav>
          </Reveal>
        </div>

        <Separator className="my-8" />

        <Reveal
          delay={260}
          className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-muted-foreground"
        >
          <p>© {new Date().getFullYear()} ROSKAM. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <span>Netherlands (NL)</span>
          </div>
        </Reveal>
      </div>
    </footer>
  );
};
